import clsx from 'clsx';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';
import L from 'leaflet';
import React, { useCallback, useEffect, useRef } from 'react';
import { VideoPlayerFunctionality } from 'types/videoPlayerTypes';
import { CameraIrisFocusControlsProps } from '../types';
import CameraCapabilities from './CameraCapabitlities';
import CameraDetections from './CameraDetections';
import CameraFocus from './CameraFocus';
import CameraIris from './CameraIris';

const CameraIrisFocusControls: React.FunctionComponent<CameraIrisFocusControlsProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const controlsRef = useRef<HTMLDivElement>(null);
  const capabilitiesMenuRef = useRef<HTMLDivElement>(null);
  const detectionsMenuRef = useRef<HTMLDivElement>(null);

  const {
    isFullScreen,
    videoPlayerFunctionalities,
    controlsButtonRef,
    showControls,
    setShowControls,
  } = props;

  const handleClickOutsideControls = useCallback(
    (event: any) => {
      showControls &&
        controlsRef.current &&
        !controlsRef.current.contains(event.target) &&
        controlsButtonRef.current &&
        !controlsButtonRef.current.contains(event.target) &&
        (!capabilitiesMenuRef.current ||
          (capabilitiesMenuRef.current && !capabilitiesMenuRef.current.contains(event.target))) &&
        (!detectionsMenuRef.current ||
          (detectionsMenuRef.current && !detectionsMenuRef.current.contains(event.target))) &&
        setShowControls(false);
    },
    [controlsButtonRef, setShowControls, showControls]
  );

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutsideControls);
    return () => {
      window.removeEventListener('mousedown', handleClickOutsideControls);
    };
  }, [controlsRef, handleClickOutsideControls]);
  return (
    <>
      {showControls && (
        <div
          ref={controlsRef}
          className={clsx(classes.cameraControlsWrapper, {
            [classes.cameraControlsFullScreen]: isFullScreen,
          })}
          onWheel={(event) => {
            L.DomEvent.stopPropagation(event as unknown as Event);
            event.stopPropagation();
          }}
        >
          {videoPlayerFunctionalities.includes(VideoPlayerFunctionality.FOCUS_CONTROL) && (
            <CameraFocus {...props} />
          )}
          {videoPlayerFunctionalities.includes(VideoPlayerFunctionality.IRIS_CONTROL) && (
            <CameraIris {...props} />
          )}
          {videoPlayerFunctionalities.includes(VideoPlayerFunctionality.CAPABILITIES) && (
            <CameraCapabilities {...props} capabilitiesMenuRef={capabilitiesMenuRef} />
          )}
          {videoPlayerFunctionalities.includes(VideoPlayerFunctionality.DETECTIONS) && (
            <CameraDetections {...props} detectionsMenuRef={detectionsMenuRef} />
          )}
        </div>
      )}
    </>
  );
};

export default CameraIrisFocusControls;
